<template>
    <div>
        <header class="main-header">
            <nav class="km-navbar navbar-static-top">
                <div class="navbar-custom-menu km-navbar-left">
                    <ul class="km-nav km-navbar-nav">
                        <li class="dropdown user user-menu">
                            <a class="currentTime">{{state.now | formatTime}}</a>
                        </li>
                        <li class="dropdown user user-menu">
                            <a class='sound'>
                                <div v-on:click="toggleAudio" v-if="timelineSettings.playSound">
                                    <i class="icon icon-mute-1-2"></i>
                                    <translate item="TimelineSettings.PlaySound.ToggleAudio.On" />
                                </div>
                                <div v-on:click="toggleAudio" v-if="!timelineSettings.playSound">
                                    <i class="icon icon-muted-1"></i>
                                    <translate item="TimelineSettings.PlaySound.ToggleAudio.Off" />
                                </div>
                            </a>
                        </li>
                        <li class="dropdown user user-menu">
                            <a class='wifi'>
                                <div>
                                    <i :class="['icon ', {'icon-internet-connection-1' : timelineSettings.connected, 'icon-internet-no-connection-1' : !timelineSettings.connected }]"></i>
                                    <translate item="UserMenu.Connection" />
                                </div>
                            </a>
                        </li>
                        <li class="dropdown user user-menu" v-if="user.name.length">
                            <a class='link'>
                                <div :title="'Naar configuratie version: ' + version" class="config" v-on:click="config()">
                                    <i class="icon icon-settings-1"></i>
                                    <translate item="UserMenu.Settings" />
                                </div>
                            </a>
                        </li>
                        <li class="dropdown user user-menu" v-if="user.name.length">
                            <ul class="units-selected" v-if="collectUnitGroups && collectUnitGroups.length">
                                <li v-for="unit in collectUnitGroups"><span>{{unit.name}}</span></li>
                            </ul>
                        </li>

                        <warmingTrays></warmingTrays>

                        <li class="dropdown user user-menu logo" :class="clickcountClass" v-on:click="openAdminPanel()">
                            <img src="/img/logo-ordergo-wit-MC.png" />
                        </li>
                        <!-- User Account: style can be found in dropdown.less -->
                        <li v-if="user.name.length && showLogout" class="dropdown user user-menu user-logout">
                            <a class='link'>
                                <div title="Account">
                                    <i class="icon icon-user"></i>
                                    <translate item="UserMenu.LoggedInAs" /> {{user.name}}
                                </div>
                            </a>
                            <a class='link'>
                                <div title="Uitloggen" v-on:click="logOut()">
                                    <i class="icon icon-logout"></i>
                                    <translate item="UserMenu.Logout" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="navbar-custom-menu km-navbar-legenda" v-if="!showLogout">
                    <div :class="['dropdown user user-menu legenda', getStatusClass(status)]" :key="status" v-for="status in StatusIds" v-on:click="filterStatus(status)">
                        <span class="legenda-status">
                            <span class="legenda-status-nr">{{status + 1}}</span>
                            <span>{{getStatusText(status)}}</span>
                            <i class="checkmark icon-checkmark-small" v-if="isFilteredStatus(status)"></i>
                        </span>
                    </div>

                    <div v-if="showHistory || user.isAdmin" class="navbar-history">
                        <div :class="['btn-history-getorders', {'history-visible':state.historySearch}]" v-on:click="getMoreOrders">
                            <i class='icon-past'></i>
                            <span><translate item="TimelineSettings.ModifyTime.GetMoreOrders" /></span>
                        </div>
                        <div class="btn-history-reset" v-if="state.historySearch" v-on:click="getMoreOrdersReset">
                            <a class="icon"><i class="icon-plus-1"></i></a>
                        </div>
                    </div>
                </div>
            </nav>
        </header>

        <div class="main-header-top">
        </div>
        <div class="main-header-bottom">
        </div>
    </div>
</template>

<script>

    import configRepository from '../repositories/ConfigRepository';
    import axios from 'axios';
    import signalR from '../repositories/signalR';
    import timeStore from '../repositories/TimeManager';
    import Vue from 'vue';
    import searchOrder from '../components/SearchOrder';
    import translate from '../components/translate'
    import { OrderStatus } from "../repositories/Constants";
    import translationService from '../repositories/TranslateService';
    import warmingTrays from '../components/WarmingTrays'

    export default {

        name: 'UserMenu',

        components: { translate, warmingTrays },

        data: function () {
            return {
                user: configRepository.user,
                version: configRepository.version,
                timelineSettings: this.$signalR.timelineSettings,
                searchString: 'web-',
                StatusIds: configRepository.statusIds,
                state: timeStore.state,
                showHistory: this.$signalR.showCollect,
                allUnitGroups: this.$signalR.units,
                clickCount: 0,
                timer: null,
                isFilterActive: false
            };
        },

        props: {
            showLogout: Boolean
        },

        methods: {
            logOut: function () {
                // axios, for a full list of options see: https://github.com/axios/axios
                axios({
                    method: 'GET',
                    url: configRepository.endPointUrl + 'account/TerminalLogout',
                    withCredentials: true
                }).then(function (response) {
                    // redirect to login page.
                    window.location = '/#login';
                }).catch(function (err) {
                    window.console.log('#UserMenu.vue: Error logout');
                    window.console.log(err);
                });

            },

            config: function () {
                window.location = '/#config';
            },

            rulerLoadDay: function (dayAdd) {
                timeStore.setStartTime(new Date(timeStore.state.startTime.getFullYear(), timeStore.state.startTime.getMonth(), timeStore.state.startTime.getDate() + dayAdd, timeStore.state.startTime.getHours(), 0, 0));
                timeStore.setEndTime(new Date(timeStore.state.endTime.getFullYear(), timeStore.state.endTime.getMonth(), timeStore.state.endTime.getDate() + dayAdd, timeStore.state.startTime.getHours(), 0, 0));
            },

            getMoreOrdersReset: function () {
                this.$signalR.getMoreOrdersReset();
            },

            getMoreOrders: function () {

                // Get selected unit groups from Config-repo
                const unitGroupIds = configRepository.getConfig().collectUnitGroupIds;

                // filter selected unit groups from Order-repo
                const visibleUnitGroups = this.$signalR.units.filter(u => unitGroupIds.includes(u.id));

                this.$signalR.getMoreOrders(visibleUnitGroups);
            },

            openAdminPanel: function () {

                if (this.user.isAdmin) {
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    this.clickCount += 1;

                    if (this.clickCount > 4) {
                        this.clickCount = 0;
                        this.openSearchModal();
                    }
                    this.timer = setTimeout(() => { this.clickCount = 0; }, 1000);
                }
               
            },
            openSearchModal: function () {

                // create  vue compnent
                // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
                var ComponentClass = Vue.extend(searchOrder)
                // set properties
                var _orderDetail = new ComponentClass({
                    propsData: { Search: this.searchString }
                });

                _orderDetail.$mount();

                // https://sweetalert2.github.io/#configuration
                this.$fire({
                    //title: "Bestelling #" + this.Order.orderNr,
                    html: '', // _orderDetail.$el.outerHTML,
                    width: '40rem',
                    padding: '0px',
                    showConfirmButton: false,
                    customClass: {
                        container: 'order-detail'
                    },
                    onOpen: function (ell) {
                        ell.children[1].appendChild(_orderDetail.$el);
                    }

                }).then((data) => {
                    _orderDetail.$destroy();
                });

            },

            getStatusText: function (statusId) {
                return translationService.GetTranslation("Order.Status." + statusId);
            },

            getStatusIconClass: function (statusId) {
                var className = {};
                className['icon'] = 1;
                className[OrderStatus[statusId]] = 1;
                return className;
            },

            getStatusClass: function (statusId) {
                let baseClass = '';

                switch (statusId) {
                    case 0: baseClass = 'pending'; break;
                    case 1: baseClass = 'preparing'; break;
                    case 2: baseClass = 'prepared'; break;
                    case 3: baseClass = 'parceling'; break;
                    case 4: baseClass = 'parceled'; break;
                }

                // Geen filter actief (lege array)
                if (!signalR.statusFilter || signalR.statusFilter.length === 0) {
                    return baseClass;
                }

                // Actieve status
                if (signalR.statusFilter.includes(statusId)) {
                    return baseClass + ' selected-status';
                }

                // Niet-actieve status
                return baseClass + ' dimmed-status';

            },

            filterStatus: function (status) {
                const index = signalR.statusFilter.indexOf(status);
                if (index > -1) {
                    signalR.statusFilter.splice(index, 1); // verwijder bestaande
                } else {
                    signalR.statusFilter.push(status); // voeg toe
                }
            },

            isFilteredStatus(statusId) {
                return Array.isArray(signalR.statusFilter) &&
                    signalR.statusFilter.includes(statusId);
            },

            toggleAudio: function () {
                this.timelineSettings.playSound = !this.timelineSettings.playSound;
                var config = configRepository.getConfig();
                config.playSound = this.timelineSettings.playSound;
                configRepository.saveConfig(config);
            },

        },

        computed: {
            clickcountClass: function () {
                return "clickcount" + this.clickCount;
            },
            collectUnitGroups: function () {
                if (this.$signalR.showCollect) {
                    // Get selected unit groups from Config-repo
                    const _collectUnitGroupIds = configRepository.getConfig().collectUnitGroupIds;

                    if (_collectUnitGroupIds) {
                        const units = this.allUnitGroups.filter(u => _collectUnitGroupIds.includes(u.id));
                        return units;
                    }
                }

            }
        }

    };

</script>

<style scoped>
</style>